module.exports = __webpack_public_path__ + "img/logo.dda646d9.svg";